<footer class="footer-create">
  <div class="footer-create-inner">
    <div class="footer-create-left">
      <span class="footer-create-label">{{ 'footerPoweredBy' | translate }}</span>
      <img src="./../../assets/logo.png" alt="Kaizen" class="footer-create-logo" />
    </div>

    <div class="footer-create-center">
      <span class="footer-create-label">{{ 'footerAlsoAvailable' | translate }}</span>
      <div class="footer-create-icons">
        <a href="https://chromewebstore.google.com/detail/kaizen-esign/adhcdcjkdfniafmfahnlijlpdlmcdhog"
           target="_blank" rel="noopener">
          <img src="./../../assets/Chrome_icon.png" alt="Chrome Web Store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.ayankaizen.esign"
           target="_blank" rel="noopener">
          <img src="./../../assets/Google_Icon.png" alt="Google Play" />
        </a>
        <a href="https://apps.apple.com/in/iphone/search?term=kaizen%20esign"><img src="./../../assets/AppStore_Icon.png" alt="App Store" /></a>
        <a href="https://marketplace.microsoft.com/en-us/product/office/WA200008076?tab=Overview"
           target="_blank" rel="noopener">
          <img src="./../../assets/Outlook.png" alt="Outlook" />
        </a>
      </div>
    </div>

    <!--
    <div class="footer-create-right">
      <span class="footer-create-label">{{ 'footerLegallyCompliant' | translate }}</span>
      <div class="footer-create-legal">
        <img src="./../../assets/AATL-LOGO-latest1.png" alt="AATL" />
        <img src="./../../assets/dsc_logo.png" alt="DSC" />
      </div>
    </div>
    -->
  </div>

  <div class="footer-create-line">
    <img src="./../../assets/footer_horizontal_Line.png" alt="" />
  </div>
</footer>
